import $ from "jquery"
import { getOptions, setOptions, getFormElementByName } from "./variables"
import _ from "../utils/lodash"

export function activefocus(obj) {
  if (obj.type !== "checkbox" && obj.type !== "radio") {
    let {
      backups,
      mfp_input_background_color_active,
      mfp_input_border_color_active,
    } = getOptions()
    const focusBackgroundColor = obj.style.backgroundColor
    const focusBorderColor = obj.style.borderColor
    backups = backups || {}
    backups[obj.name] = {
      focusBackgroundColor,
      focusBorderColor,
    }
    setOptions({ backups })
    obj.style.backgroundColor = mfp_input_background_color_active
    obj.style.borderColor = mfp_input_border_color_active
  }
}
export function lostfocus(obj) {
  if (obj.type !== "checkbox" && obj.type !== "radio") {
    const { backups } = getOptions()
    const { focusBackgroundColor, focusBorderColor } = backups[obj.name]

    obj.style.backgroundColor = focusBackgroundColor
    obj.style.borderColor = focusBorderColor
    if (obj.type === "text" || obj.type === "textarea") formatCharset(obj)
  }
}

function formatCharset(obj) {
  var before = [
    "ｶﾞ",
    "ｷﾞ",
    "ｸﾞ",
    "ｹﾞ",
    "ｺﾞ",
    "ｻﾞ",
    "ｼﾞ",
    "ｽﾞ",
    "ｾﾞ",
    "ｿﾞ",
    "ﾀﾞ",
    "ﾁﾞ",
    "ﾂﾞ",
    "ﾃﾞ",
    "ﾄﾞ",
    "ﾊﾞ",
    "ﾋﾞ",
    "ﾌﾞ",
    "ﾍﾞ",
    "ﾎﾞ",
    "ﾊﾟ",
    "ﾋﾟ",
    "ﾌﾟ",
    "ﾍﾟ",
    "ﾎﾟ",
    "ｦ",
    "ｧ",
    "ｨ",
    "ｩ",
    "ｪ",
    "ｫ",
    "ｬ",
    "ｭ",
    "ｮ",
    "ｯ",
    "ｰ",
    "ｱ",
    "ｲ",
    "ｳ",
    "ｴ",
    "ｵ",
    "ｶ",
    "ｷ",
    "ｸ",
    "ｹ",
    "ｺ",
    "ｻ",
    "ｼ",
    "ｽ",
    "ｾ",
    "ｿ",
    "ﾀ",
    "ﾁ",
    "ﾂ",
    "ﾃ",
    "ﾄ",
    "ﾅ",
    "ﾆ",
    "ﾇ",
    "ﾈ",
    "ﾉ",
    "ﾊ",
    "ﾋ",
    "ﾌ",
    "ﾍ",
    "ﾎ",
    "ﾏ",
    "ﾐ",
    "ﾑ",
    "ﾒ",
    "ﾓ",
    "ﾔ",
    "ﾕ",
    "ﾖ",
    "ﾗ",
    "ﾘ",
    "ﾙ",
    "ﾚ",
    "ﾛ",
    "ﾜ",
    "ﾝ",
    "Ａ",
    "Ｂ",
    "Ｃ",
    "Ｄ",
    "Ｅ",
    "Ｆ",
    "Ｇ",
    "Ｈ",
    "Ｉ",
    "Ｊ",
    "Ｋ",
    "Ｌ",
    "Ｍ",
    "Ｎ",
    "Ｏ",
    "Ｐ",
    "Ｑ",
    "Ｒ",
    "Ｓ",
    "Ｔ",
    "Ｕ",
    "Ｖ",
    "Ｗ",
    "Ｘ",
    "Ｙ",
    "Ｚ",
    "ａ",
    "ｂ",
    "ｃ",
    "ｄ",
    "ｅ",
    "ｆ",
    "ｇ",
    "ｈ",
    "ｉ",
    "ｊ",
    "ｋ",
    "ｌ",
    "ｍ",
    "ｎ",
    "ｏ",
    "ｐ",
    "ｑ",
    "ｒ",
    "ｓ",
    "ｔ",
    "ｕ",
    "ｖ",
    "ｗ",
    "ｘ",
    "ｙ",
    "ｚ",
    "＠",
    "０",
    "１",
    "２",
    "３",
    "４",
    "５",
    "６",
    "７",
    "８",
    "９",
    "．",
    "①",
    "②",
    "③",
    "④",
    "⑤",
    "⑥",
    "⑦",
    "⑧",
    "⑨",
    "⑩",
    "Ⅰ",
    "Ⅱ",
    "Ⅲ",
    "Ⅳ",
    "Ⅴ",
    "Ⅵ",
    "Ⅶ",
    "Ⅷ",
    "Ⅸ",
    "Ⅹ",
    "㈱",
    "㈲",
  ]
  var after = [
    "ガ",
    "ギ",
    "グ",
    "ゲ",
    "ゴ",
    "ザ",
    "ジ",
    "ズ",
    "ゼ",
    "ゾ",
    "ダ",
    "ヂ",
    "ヅ",
    "デ",
    "ド",
    "バ",
    "ビ",
    "ブ",
    "ベ",
    "ボ",
    "パ",
    "ピ",
    "プ",
    "ペ",
    "ポ",
    "ヲ",
    "ァ",
    "ィ",
    "ゥ",
    "ェ",
    "ォ",
    "ャ",
    "ュ",
    "ョ",
    "ッ",
    "ー",
    "ア",
    "イ",
    "ウ",
    "エ",
    "オ",
    "カ",
    "キ",
    "ク",
    "ケ",
    "コ",
    "サ",
    "シ",
    "ス",
    "セ",
    "ソ",
    "タ",
    "チ",
    "ツ",
    "テ",
    "ト",
    "ナ",
    "ニ",
    "ヌ",
    "ネ",
    "ノ",
    "ハ",
    "ヒ",
    "フ",
    "ヘ",
    "ホ",
    "マ",
    "ミ",
    "ム",
    "メ",
    "モ",
    "ヤ",
    "ユ",
    "ヨ",
    "ラ",
    "リ",
    "ル",
    "レ",
    "ロ",
    "ワ",
    "ン",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "@",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    ".",
    "(1)",
    "(2)",
    "(3)",
    "(4)",
    "(5)",
    "(6)",
    "(7)",
    "(8)",
    "(9)",
    "(10)",
    "(1)",
    "(2)",
    "(3)",
    "(4)",
    "(5)",
    "(6)",
    "(7)",
    "(8)",
    "(9)",
    "(10)",
    "(株)",
    "(有)",
  ]
  before.map((bc, index) => {
    obj.value = obj.value.split(bc).join(after[index])
  })

  var temp = new Array()
  temp = obj.value.split("\n")
  for (var i = 0; i < temp.length; i++) {
    if (temp[i].length > 64) {
      var chars = new Array()
      chars = temp[i].split("")
      for (var ii = 63; ii < chars.length; ii += 63) {
        chars[ii] += "\n"
      }
      temp[i] = chars.join("")
    }
  }
  obj.value = temp.join("\n")
}

function mfp_errmsg(objId, msg) {
  if (document.getElementById("errormsg_" + objId)) {
    document.getElementById("errormsg_" + objId).innerHTML = msg
    document.getElementById("errormsg_" + objId).style.display = "block"
  }
}
function mfp_errmsg_reset(objId) {
  if (document.getElementById("errormsg_" + objId)) {
    document.getElementById("errormsg_" + objId).innerHTML = ""
    document.getElementById("errormsg_" + objId).style.display = "none"
  }
}

export function keepField() {
  const { obj, conservationKey } = getOptions()

  const formValues = Object.values(obj)
    .filter((element) => {
      return (
        element.type !== "hidden" &&
        element.type !== "file" &&
        element.type !== "button" &&
        element.type !== "submit" &&
        element.type !== "image"
      )
    })
    .map((element) => {
      if (element.type == "checkbox" || element.type == "radio") {
        if (element.id) {
          labelclick(document.getElementById(element.id + "_label"))
        }

        return element.checked ? 1 : 0
      } else if (element.type == "text" || element.type == "textarea") {
        return escape(element.value)
      } else if (element.type === "select-multiple") {
        const selected_multiple = _.filter(element.options, ["selected"])
        return selected_multiple.join(",")
      } else if (element.type == "select-one") {
        return element.selectedIndex
      }
    })

  mfp_setCookie(
    "mailform",
    conservationKey + formValues.join("&") + conservationKey
  )
}

export const mfp_setCookie = (name, val) => {
  let current_dir = location.pathname
  const current_dirs = current_dir.split("/")
  if (current_dirs[current_dirs.length - 1] != "") {
    current_dirs[current_dirs.length - 1] = ""
    current_dir = current_dirs.join("/")
  }

  Cookies.set(name, val, { path: current_dir, expires: 7 })
}

export function mfpf(obj) {
  const { mfp_input_text_color_default } = getOptions()

  if (
    obj.value === obj.defaultValue &&
    (obj.type === "text" || obj.type === "textarea")
  ) {
    obj.value = ""
    obj.style.color = mfp_input_text_color_default
  }
  activefocus(obj)
  setOptions({ focuselements: obj })
}

export function mfpb(obj) {
  if (
    (obj.value === obj.defaultValue || obj.value === "") &&
    (obj.type === "text" || obj.type === "textarea")
  ) {
    obj.value = obj.defaultValue
  }
  keepField()
  lostfocus(obj)
  mfp_checkelement(obj)
}

export function mfpclick(obj) {
  if (obj.type === "radio" || obj.type === "checkbox") {
    keepField()
    lostfocus(obj)
    mfp_checkelement(obj)
  }
}

export function labelclick(obj) {
  if (obj?.id) {
    const elementId = obj.id.replace(/_label/g, "")
    if (document.getElementById(elementId)) {
      if (document.getElementById(elementId).checked)
        obj.className += " label_true"
      else obj.className += " label_false"
    }
  }
}

export function mfp_checkelement(obj) {
  const { must_id, mfp_emailaddress, mfp_confirmed_emailaddress } = getOptions()

  const elementType = obj.type
  const elements_infos = obj.name.split(must_id)
  const errortext = elements_infos[0]
  const must_maxed = elements_infos[1] || 1
  const must_flag = obj.disabled ? -1 : obj.name.indexOf(must_id, 0)

  var error_message = ""
  mfp_errmsg_reset(errortext)

  if (errortext === "email" || errortext === "confirm_email") {
    const chkMail = obj.value
    setOptions({ email_address: chkMail })
    const check = /.+@.+\..+/
    if (errortext === "email") {
      setOptions({ mfp_emailaddress: chkMail })
    }
    if (mfp_emailaddress != obj.value && errortext === "confirm_email")
      error_message = mfp_langObj[mfp_lang][0]
    else if (
      must_flag > -1 &&
      chkMail === obj.defaultValue &&
      errortext === "confirm_email"
    ) {
      error_message = mfp_langObj[mfp_lang][1]
      setOptions({ mfp_confirmed_emailaddress: chkMail })
    } else if (must_flag > -1 && obj.value === obj.defaultValue)
      error_message = mfp_langObj[mfp_lang][2]
    else if (!chkMail.match(check) && obj.value !== obj.defaultValue)
      error_message = mfp_langObj[mfp_lang][3]
  } else if (elementType === "file") {
    if (obj.value === "" && must_flag > -1) {
      error_message = errortext + mfp_langObj[mfp_lang][7]
    } else if (obj.value !== "") {
      const mfp_fileTypes = obj.value.split(".")
      const mfp_fileType = mfp_fileTypes[mfp_fileTypes.length - 1].toLowerCase()
      const mfp_obverseTypes = obj.name.split("/")[1].split(",")
      var mfp_fileFlag = mfp_obverseTypes.filter((obverseType) => {
        return obverseType === mfp_fileType
      })
      if (mfp_fileFlag.length === 0) {
        if (must_flag > -1) {
          error_message = errortext + mfp_langObj[mfp_lang][14]
        } else {
          const file_element_name = obj.name.split("(file)")
          error_message = file_element_name[0] + mfp_langObj[mfp_lang][14]
        }
      } else {
        const file_element_name = obj.name.split("(file)")[0]
        mfp_errmsg_reset(file_element_name)
      }
    }
  } else if (must_flag > -1) {
    const element = getFormElementByName(obj.name)
    if (
      (elementType == "text" || elementType == "textarea") &&
      (obj.value === "" || obj.value === obj.defaultValue)
    )
      error_message = errortext + mfp_langObj[mfp_lang][4]
    else if (elementType === "checkbox" || elementType === "radio") {
      if (_.isArray(element) && element.length > 0) {
        const checkbox_checked_count = _.reduce(element, (sum, n) => {
          return sum + n.checked ? 1 : 0
        })
        if (checkbox_checked_count < must_maxed)
          error_message =
            errortext + mfp_langObj[mfp_lang][5].replace("<CNT>", must_maxed)
      } else if (!element.checked)
        error_message = errortext + mfp_langObj[mfp_lang][6]
    } else if (
      elementType == "select-multiple" ||
      elementType == "select-one"
    ) {
      if (obj.selectedIndex > -1) {
        const selectCnt = obj.selectedIndex
        if (obj.options[selectCnt].value === "")
          error_message = errortext + mfp_langObj[mfp_lang][7]
      } else error_message = errortext + mfp_langObj[mfp_lang][7]
    }
  }
  const ex_error_message = MFP_EX_ELEMENT_CHECK(obj)
  if (ex_error_message != undefined) error_message = ex_error_message
  if (error_message !== "") {
    errorElementsStyle(obj)
    mfp_errmsg(errortext, error_message)
  } else {
    greenElementsStyle(obj)
  }
  return error_message
}

function errorElementsStyle(obj) {
  if (obj.type != "button" && obj.type != "checkbox" && obj.type != "radio") {
    const { mfp_input_text_color_error, mfp_input_background_color_error } =
      getOptions()
    obj.style.backgroundColor = mfp_input_background_color_error
    obj.style.color = mfp_input_text_color_error
  }
}

function greenElementsStyle(obj) {
  if (obj.type != "button" && obj.type != "checkbox" && obj.type != "radio") {
    const { mfp_input_background_color_default, mfp_input_text_color_default } =
      getOptions()
    obj.style.backgroundColor = mfp_input_background_color_default
    obj.style.color = mfp_input_text_color_default
  }
}

export function selectedHidden() {
  const { obj } = getOptions()
  _.mapValues(obj, (elem) => {
    if (elem.type === "select-multiple" || elem.type === "select-one") {
      elem.style.visibility = "hidden"
    }
  })
}

export function selectedVisible() {
  const { obj } = getOptions()
  _.mapValues(obj, (elem) => {
    if (elem.type === "select-multiple" || elem.type === "select-one") {
      elem.style.visibility = "visible"
    }
  })
}
